import React, { useContext } from "react";

/// React router dom
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import Setting from "./layouts/Setting";
//import Main from './layouts/Main';

import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import Draggable from "./components/Dashboard/Draggable";
import ProjectDetails from "./components/Dashboard/ProjectDetails";
import Messages from "./components/Dashboard/Messages";
import LatestActivity from "./components/Dashboard/LatestActivity";
import Clients from "./components/Dashboard/Clients";
import Task from "./components/Dashboard/Task";

//Demo
import Theme1 from "./components/Dashboard/Demo/Theme1";
import Theme2 from "./components/Dashboard/Demo/Theme2";
import Theme3 from "./components/Dashboard/Demo/Theme3";
import Theme4 from "./components/Dashboard/Demo/Theme4";
import Theme5 from "./components/Dashboard/Demo/Theme5";
import Theme6 from "./components/Dashboard/Demo/Theme6";


/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
////import Chartist from "./components/charts/chartist";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainNouiSlider from "./components/PluginsMenu/NouiSlider/MainNouiSlider";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

//Redux
//import Todo from "./pages/Todo";

// Widget
import Widget from "./pages/Widget";

/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import BootstrapTable from "./components/table/BootstrapTable";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages
//import Registration from "./pages/Registration";
//import Login from "./pages/Login";
//import ForgotPassword from "./pages/ForgotPassword";
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import UserList from "./users/userlist";
import AddUser from "./users/adduser";
import EditUser from "./users/edituser";
import ProjectList from "./projects/projectlist";
import AddProject from "./projects/addproject";
import EditProject from "./projects/editproject";
import TaskList from "./tasks/tasklist";
import AddTask from "./tasks/addtask";
import EditTask from "./tasks/edittask";
import Modules from "./modules/modules";
import Subscription from "./components/AppsMenu/AppProfile/subscription";
import TaskBoard from "./tasks/taskboard";
import TaskDetails from "./tasks/taskdetails";
import PrivateRoutes from '../PrivateRoutes';
import Login from './pages/Login';
import Registration from './pages/Registration';
import HomeLanding from "./pages/HomeLanding";
import AboutSystem from "./pages/AboutSystem";
import Products from "./pages/Products";
import ProductsTask from "./pages/ProductsTask";
import ProductsDocuments from "./pages/ProductsDocuments";
import ProductsCredentialVault from "./pages/ProductsCredentialVault";
import SubscriptionPackages from "./pages/SubscriptionPackages";
import ContactUs from "./pages/ContactUs";
import PublicNavbar from "./layouts/PublicNavbar";
import EditProfilePage from "./layouts/nav/EditProfilePage";
import UserSubscription from "./pages/UserSubscription";
import TermsAndConditions from "./pages/terms";
import PrivacyPolicy from "./pages/Privacy";
import RefundCancellationPolicy from "./pages/RefundCancellationPolicy";
import RootRoute from "./components/RootRoute";
import PublicPageWrapper from "./components/PublicPageWrapper";

import ChangePassword from './users/changePassword';
import AddBranch from './settings/addBranch';
import EditBranch from './settings/editBranch';
import AddDepartment from './settings/addDepartment';
import EditDepartment from './settings/editDepartment';
import AddDesignation from './settings/addDesignation.js';
import DesignationList from "./settings/designationList.js";
import AddStaff from './staff/addStaff.js';
import StaffList from './staff/staffList.js';
import EditStaff from './staff/editStaff.js';
import StaffDetails from './staff/staffDetails.js';
import StaffAddressForm from './staff/StaffAddressForm.js';
import StaffContactForm from './staff/StaffContactForm.js';
import StaffEmploymentForm from './staff/StaffEmploymentForm.js';
import StaffDocumentForm from './staff/StaffDocumentForm.js';

import ForgotPassword from './pages/SendResetLink';
import ResetPassword from './pages/ResetPassword';
import RegistrationSubscriptionPlans from './pages/RegistrationSubscriptionPlans';
import TestSubscriptionPlans from './pages/TestSubscriptionPlans';
import Worksheet from "./tasks/worksheet";
import PerformanceDashboard from "./tasks/performanceDashboard";
import PerformanceDetails from "./tasks/performanceDetails";
import BranchList from "./settings/listbranch";
import DepartmentList from "./settings/listdepartments";
import UserSettings from "./settings/userSettings";
import AddSubDepartment from "./settings/addSubDepartment";
import EditSubDepartment from "./settings/editSubDepartment";
import SubDepartmentList from "./settings/subDepartmentList";
import AccessControl from "./settings/accessControl";

import CredentialVaultList from './credentialVault/credentialVaultList';
import PersonalVaultList from './credentialVault/personalVaultList';
import CredentialVaultForm from './credentialVault/credentialVaultForm';
import CredentialVaultDetail from './credentialVault/credentialVaultDetail';

//vehicle
import AddVehicle from "./vehicle/addVehicle";
import VehicleList from "./vehicle/vehicleList";
import EditVehicle from "./vehicle/editVehicle";
import VehicleDetails from "./vehicle/vehicleDetails";
import VehicleDocumentForm from "./vehicle/VehicleDocumentForm";
import VehicleInsuranceForm from "./vehicle/VehicleInsuranceForm";
import VehicleRegistrationForm from "./vehicle/VehicleRegistrationForm";

import DocumentList from "./Documents/documentList";
import AddDocumentCategory from "./Documents/AddDocumentCatagory.js";
import DocumentCategoryList from "./Documents/DocumentCatagoryList.js";
import DocumentsDashboard from "./Documents/recentDocuments";
import DocumentDetails from "./Documents/documentDetails.js";
import SharedDocuments from "./Documents/sharedDocuments.js";
import FavoriteDocuments from "./Documents/favoriteDocuments.js";
import SharedDocumentViewer from "./Documents/SharedDocumentViewer.js";
import AddDocument from "./Documents/AddDocument.js";
import EditDocument from "./Documents/EditDocument.js";
import StaffDocumentDetails from "./staff/StaffDocumentDetails.js";
import VehicleDocumentDetails from "./vehicle/VehicleDocumentDetails.js";
import SubscriptionFeatureRequired from "./pages/SubscriptionFeatureRequired.js";
import SubscriptionPaymentResult from "./pages/SubscriptionPaymentResult.js";
import SubscriptionPaymentSuccess from "./pages/SubscriptionPaymentSuccess.js";
import TaskDailyUpdatesList from "./tasks/TaskDailyUpdatesList.js";
import SubscriptionCheckout from "./pages/SubscriptionCheckout.js";
import SubscriptionRenewal from "./pages/SubscriptionRenewal.js";
import VaultSettings from "./credentialVault/vaultSettings.jsx";

const PublicLayout = ({ children }) => (
  <>
    <PublicNavbar />
    <div style={{ paddingTop: '85px' }}>{children}</div>
  </>
);

const Markup = () => {

  const allroutes = [
    //dashboard
    { url: '/home', component: <Home /> },
    //users
    { url: '/settings/userlist', component: <UserList /> },
    { url: '/settings/adduser', component: <AddUser /> },
    { url: '/settings/edituser', component: <EditUser /> },

    //staff
    { url: '/staff/staffList', component: <StaffList /> },
    { url: '/staff/addStaff', component: <AddStaff /> },
    { url: '/staff/editStaff/:id', component: <EditStaff /> },
    { url: '/staff/staffDetails/:id', component: <StaffDetails /> },
    { url: '/staff/:staffId/address/add', component: <StaffAddressForm /> },
    { url: '/staff/:staffId/address/:addressId/edit', component: <StaffAddressForm /> },
    { url: '/staff/:staffId/contact/add', component: <StaffContactForm /> },
    { url: '/staff/:staffId/contact/:contactId/edit', component: <StaffContactForm /> },
    { url: '/staff/:staffId/employment/add', component: <StaffEmploymentForm /> },
    { url: '/staff/:staffId/employment/:employmentId/edit', component: <StaffEmploymentForm /> },
    { url: '/staff/:staffId/document/add', component: <StaffDocumentForm /> },
    { url: '/staff/:staffId/document/:documentId/edit', component: <StaffDocumentForm /> },
    { url: '/staff/:staffId/document/:documentId', component: <StaffDocumentDetails /> },

    //projects
    { url: '/task/projectlist', component: <ProjectList /> },
    { url: '/task/addproject', component: <AddProject /> },
    { url: '/task/editproject', component: <EditProject /> },
    { url: '/task/projectdetails/:projectId', component: <ProjectDetails /> },
    { url: '/task/worksheet', component: <Worksheet /> },
    { url: '/task/performance', component: <PerformanceDashboard /> },
    { url: '/task/performance/details', component: <PerformanceDetails /> },
    { url: '/subscription-feature-required', component: <SubscriptionFeatureRequired /> },
    { url: '/task/taskdetails/:taskid/daily-updates', component: <TaskDailyUpdatesList /> },
    { url: '/task/projectdetails/:projectId/daily-updates', component: <TaskDailyUpdatesList /> },


    //tasks
    { url: '/task/tasklist', component: <TaskList /> },
    { url: '/task/addtask', component: <AddTask /> },
    { url: '/task/edittask', component: <EditTask /> },
    { url: '/taskboard', component: <TaskBoard /> },

    { url: '/modules', component: <Modules /> },
    { url: '/subscribe', component: <Subscription /> },
    { url: '/task/taskdetails/:taskid', component: <TaskDetails /> },
    { url: '/user-subscription', component: <UserSubscription /> },
    { url: '/subscription/payment-result', component: <SubscriptionPaymentResult /> },
    { url: '/subscription/payment-success', component: <SubscriptionPaymentSuccess /> },
    { url: '/changePassword', component: <ChangePassword /> },
    { url: 'settings/addBranch', component: <AddBranch /> },
    { url: 'settings/editBranch/:id', component: <EditBranch /> },
    { url: 'settings/addDepartment', component: <AddDepartment /> },
    { url: 'settings/editDepartment/:id', component: <EditDepartment /> },
    { url: 'settings/branchList', component: <BranchList /> },
    { url: 'settings/departmentList', component: <DepartmentList /> },
    { url: 'settings/userSettings', component: <UserSettings /> },
    { url: 'settings/accessControl', component: <AccessControl /> },
    { url: 'settings/addSubDepartment', component: <AddSubDepartment /> },
    { url: 'settings/editSubDepartment/:id', component: <EditSubDepartment /> },
    { url: 'settings/subDepartmentList', component: <SubDepartmentList /> },
    { url: 'settings/addDesignation', component: <AddDesignation /> },
    { url: 'settings/designationList', component: <DesignationList /> },
    { url: 'subscription/checkout', component: <SubscriptionCheckout /> },
    { url: 'subscription/renew', component: <SubscriptionRenewal /> },

    { url: 'credential-vault/credentialVaultList', component: <CredentialVaultList /> },
    { url: 'credential-vault/personalVaultList', component: <PersonalVaultList /> },
    { url: 'credential-vault/credentialDetail/:id', component: <CredentialVaultDetail /> },
    { url: 'credential-vault/addCredential', component: <CredentialVaultForm /> },
    { url: 'credential-vault/editCredential/:id', component: <CredentialVaultForm /> },
    { url: 'credential-vault/vaultSettings', component: <VaultSettings /> },

    //Vehicle
    { url: 'vehicle/addVehicle', component: <AddVehicle /> },
    { url: 'vehicle/vehicleList', component: <VehicleList /> },
    { url: 'vehicle/editVehicle/:id', component: <EditVehicle /> },
    { url: 'vehicle/vehicleDetails/:id', component: <VehicleDetails /> },
    { url: 'vehicle/:vehicleId/document/add', component: <VehicleDocumentForm /> },
    { url: 'vehicle/:vehicleId/document/:documentId/edit', component: <VehicleDocumentForm /> },
    { url: 'vehicle/:vehicleId/insurance/add', component: <VehicleInsuranceForm /> },
    { url: 'vehicle/:vehicleId/insurance/:insuranceId/edit', component: <VehicleInsuranceForm /> },
    { url: 'vehicle/:vehicleId/registration/add', component: <VehicleRegistrationForm /> },
    { url: 'vehicle/:vehicleId/registration/:registrationId/edit', component: <VehicleRegistrationForm /> },
    { url: 'vehicle/:vehicleId/document/:documentId', component: <VehicleDocumentDetails /> },

    //Document
    { url: 'documents/mydocuments', component: <DocumentList /> },
    { url: 'documents/folder/:folderId', component: <DocumentList /> },
    { url: 'documents/dashboard', component: <DocumentsDashboard /> },
    { url: 'documents/addDocumentClassification', component: <AddDocumentCategory /> },
    { url: 'documents/editDocumentClassification/:id', component: <AddDocumentCategory /> },
    { url: 'documents/documentClassifications', component: <DocumentCategoryList /> },
    { url: 'documents/details/:documentId', component: <DocumentDetails /> },
    { url: 'documents/shared', component: <SharedDocuments /> },
    { url: 'documents/favorites', component: <FavoriteDocuments /> },
    { url: 'documents/upload', component: <AddDocument /> },
    { url: 'documents/edit/:documentId', component: <EditDocument /> },
  ]

  //let path = window.location.pathname;
  //path = path.split("/");
  //path = path[path.length - 1];

  //let pagePath = path.split("-").includes("page");
  //const { menuToggle } = useContext(ThemeContext);

  return (
    <>
      <Routes>
        {/* Root route with authentication check */}
        <Route path="/" element={<RootRoute />} />
        <Route path="/about-us" element={<PublicLayout><AboutSystem /></PublicLayout>} />
        <Route path="/products" element={<PublicLayout><Products /></PublicLayout>} />
        <Route path="/products/task" element={<PublicLayout><ProductsTask /></PublicLayout>} />
        <Route path="/products/documents" element={<PublicLayout><ProductsDocuments /></PublicLayout>} />
        <Route path="/products/credentials-vault" element={<PublicLayout><ProductsCredentialVault /></PublicLayout>} />
        <Route path="/pricing" element={<PublicLayout><SubscriptionPackages /></PublicLayout>} />
        <Route path="/contact-us" element={<PublicLayout><ContactUs /></PublicLayout>} />
        <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
        <Route path="/register" element={<PublicLayout><Registration /></PublicLayout>} />
        <Route path="/terms-and-conditions" element={<PublicLayout><TermsAndConditions /></PublicLayout>} />
        <Route path="/refund-cancellation-policy" element={<PublicLayout><RefundCancellationPolicy /></PublicLayout>} />
        <Route path="/privacy-policy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
        <Route path='/forgot-password' element={<PublicLayout><ForgotPassword /></PublicLayout>} />
        <Route path='/reset-password' element={<PublicLayout><ResetPassword /></PublicLayout>} />
        <Route path='/registration-subscription' element={<PublicLayout><RegistrationSubscriptionPlans /></PublicLayout>} />
        <Route path='/test-subscription' element={<PublicLayout><TestSubscriptionPlans /></PublicLayout>} />
        <Route path='/shared' element={<PublicLayout><SharedDocumentViewer /></PublicLayout>} />
        {/* Private routes */}
        <Route path='page-lock-screen' element={<LockScreen />} />
        <Route path='page-error-400' element={<Error400 />} />
        <Route path='page-error-403' element={<Error403 />} />
        <Route path='page-error-404' element={<Error404 />} />
        <Route path='page-error-500' element={<Error500 />} />
        <Route path='page-error-503' element={<Error503 />} />
        <Route element={<PrivateRoutes />} >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
          <Route path="edit-profile" element={<EditProfilePage />} />
        </Route>
      </Routes>
      {/* <Setting /> */}
      <ScrollToTop />
    </>
  );
};


function MainLayout() {
  const { menuToggle } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" data-header-position="fixed" data-sidebar-position="fixed" data-layout="vertical" className={`show ${menuToggle ? "menu-toggle" : ""}`}>
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height - 45 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )

};

export default Markup;